export enum AudienceEnum {
  Babies = "babies",
  Children = "children",
  YoungMen = "youngMen",
  YoungWomen = "youngWomen",
  Women = "women",
  Men = "men",
  OldWomen = "oldWomen",
  OldMen = "oldMen",
}

